module.exports = require("core-js/modules/web.url-search-params.js");